var map = {
	"./alema_amendoim_p.webp": 2852,
	"./alema_branca_p.webp": 8682,
	"./alema_nozes_p.webp": 7942,
	"./alema_ovomaltine_p.webp": 1464,
	"./alema_p.webp": 7089,
	"./alema_sem_acucar_p.webp": 3006,
	"./ameixa_p.webp": 6287,
	"./amendoim_sem_acucar_p.webp": 6075,
	"./banana_p.webp": 3697,
	"./banoffee_p.webp": 769,
	"./bombonzao_p.webp": 4651,
	"./brigadeiro_p.webp": 3754,
	"./brownie_morango_p.webp": 8712,
	"./brownie_p.webp": 5476,
	"./cafe_p.webp": 2987,
	"./caramelo_p.webp": 8768,
	"./cheesecake_goiaba_p.webp": 1082,
	"./cheesecake_nutella_p.webp": 1170,
	"./cheesecake_p.webp": 9623,
	"./cheesecake_sem_acucar_p.webp": 808,
	"./chocolatra_p.webp": 1700,
	"./damasco_p.webp": 8265,
	"./docedelicia_p.webp": 8916,
	"./domino_p.webp": 4220,
	"./donaana_p.webp": 3099,
	"./feitico_p.webp": 8929,
	"./gabriela_p.webp": 9482,
	"./limao_p.webp": 2665,
	"./maca_p.webp": 6459,
	"./maracuja_p.webp": 7877,
	"./menta_p.webp": 2518,
	"./mesclada_p.webp": 8516,
	"./morango_p.webp": 8696,
	"./mousse_brigadeiro_p.webp": 7559,
	"./mousse_p.webp": 130,
	"./mousse_sem_acucar_p.webp": 29,
	"./nozes_p.webp": 8042,
	"./paodemel_p.webp": 7324,
	"./pontanegra_p.webp": 6836,
	"./profiterolis_p.webp": 9366,
	"./redvelvet_p.webp": 2437,
	"./romeu_p.webp": 3974,
	"./seducao_p.webp": 2719,
	"./spumone_p.webp": 2620,
	"./tentacao_p.webp": 2958,
	"./tropical_p.webp": 6705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6077;